import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Creator\AutomationController::store
* @see app/Http/Controllers/Creator/AutomationController.php:76
* @route '/app/creator/automations'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/app/creator/automations',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::store
* @see app/Http/Controllers/Creator/AutomationController.php:76
* @route '/app/creator/automations'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::store
* @see app/Http/Controllers/Creator/AutomationController.php:76
* @route '/app/creator/automations'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::store
* @see app/Http/Controllers/Creator/AutomationController.php:76
* @route '/app/creator/automations'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::store
* @see app/Http/Controllers/Creator/AutomationController.php:76
* @route '/app/creator/automations'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
export const show = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/app/creator/automations/{automation}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
show.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return show.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
show.get = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
show.head = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
const showForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
showForm.get = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::show
* @see app/Http/Controllers/Creator/AutomationController.php:29
* @route '/app/creator/automations/{automation}'
*/
showForm.head = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::update
* @see app/Http/Controllers/Creator/AutomationController.php:102
* @route '/app/creator/automations/{automation}'
*/
export const update = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/app/creator/automations/{automation}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::update
* @see app/Http/Controllers/Creator/AutomationController.php:102
* @route '/app/creator/automations/{automation}'
*/
update.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return update.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::update
* @see app/Http/Controllers/Creator/AutomationController.php:102
* @route '/app/creator/automations/{automation}'
*/
update.put = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::update
* @see app/Http/Controllers/Creator/AutomationController.php:102
* @route '/app/creator/automations/{automation}'
*/
const updateForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::update
* @see app/Http/Controllers/Creator/AutomationController.php:102
* @route '/app/creator/automations/{automation}'
*/
updateForm.put = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::destroy
* @see app/Http/Controllers/Creator/AutomationController.php:139
* @route '/app/creator/automations/{automation}'
*/
export const destroy = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/app/creator/automations/{automation}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::destroy
* @see app/Http/Controllers/Creator/AutomationController.php:139
* @route '/app/creator/automations/{automation}'
*/
destroy.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return destroy.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::destroy
* @see app/Http/Controllers/Creator/AutomationController.php:139
* @route '/app/creator/automations/{automation}'
*/
destroy.delete = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::destroy
* @see app/Http/Controllers/Creator/AutomationController.php:139
* @route '/app/creator/automations/{automation}'
*/
const destroyForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::destroy
* @see app/Http/Controllers/Creator/AutomationController.php:139
* @route '/app/creator/automations/{automation}'
*/
destroyForm.delete = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::activate
* @see app/Http/Controllers/Creator/AutomationController.php:155
* @route '/app/creator/automations/{automation}/activate'
*/
export const activate = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: activate.url(args, options),
    method: 'post',
})

activate.definition = {
    methods: ["post"],
    url: '/app/creator/automations/{automation}/activate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::activate
* @see app/Http/Controllers/Creator/AutomationController.php:155
* @route '/app/creator/automations/{automation}/activate'
*/
activate.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return activate.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::activate
* @see app/Http/Controllers/Creator/AutomationController.php:155
* @route '/app/creator/automations/{automation}/activate'
*/
activate.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: activate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::activate
* @see app/Http/Controllers/Creator/AutomationController.php:155
* @route '/app/creator/automations/{automation}/activate'
*/
const activateForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: activate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::activate
* @see app/Http/Controllers/Creator/AutomationController.php:155
* @route '/app/creator/automations/{automation}/activate'
*/
activateForm.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: activate.url(args, options),
    method: 'post',
})

activate.form = activateForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::pause
* @see app/Http/Controllers/Creator/AutomationController.php:173
* @route '/app/creator/automations/{automation}/pause'
*/
export const pause = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

pause.definition = {
    methods: ["post"],
    url: '/app/creator/automations/{automation}/pause',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::pause
* @see app/Http/Controllers/Creator/AutomationController.php:173
* @route '/app/creator/automations/{automation}/pause'
*/
pause.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return pause.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::pause
* @see app/Http/Controllers/Creator/AutomationController.php:173
* @route '/app/creator/automations/{automation}/pause'
*/
pause.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::pause
* @see app/Http/Controllers/Creator/AutomationController.php:173
* @route '/app/creator/automations/{automation}/pause'
*/
const pauseForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::pause
* @see app/Http/Controllers/Creator/AutomationController.php:173
* @route '/app/creator/automations/{automation}/pause'
*/
pauseForm.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: pause.url(args, options),
    method: 'post',
})

pause.form = pauseForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::duplicate
* @see app/Http/Controllers/Creator/AutomationController.php:185
* @route '/app/creator/automations/{automation}/duplicate'
*/
export const duplicate = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

duplicate.definition = {
    methods: ["post"],
    url: '/app/creator/automations/{automation}/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::duplicate
* @see app/Http/Controllers/Creator/AutomationController.php:185
* @route '/app/creator/automations/{automation}/duplicate'
*/
duplicate.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return duplicate.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::duplicate
* @see app/Http/Controllers/Creator/AutomationController.php:185
* @route '/app/creator/automations/{automation}/duplicate'
*/
duplicate.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::duplicate
* @see app/Http/Controllers/Creator/AutomationController.php:185
* @route '/app/creator/automations/{automation}/duplicate'
*/
const duplicateForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::duplicate
* @see app/Http/Controllers/Creator/AutomationController.php:185
* @route '/app/creator/automations/{automation}/duplicate'
*/
duplicateForm.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: duplicate.url(args, options),
    method: 'post',
})

duplicate.form = duplicateForm

/**
* @see \App\Http\Controllers\Creator\AutomationController::enroll
* @see app/Http/Controllers/Creator/AutomationController.php:226
* @route '/app/creator/automations/{automation}/enroll'
*/
export const enroll = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: enroll.url(args, options),
    method: 'post',
})

enroll.definition = {
    methods: ["post"],
    url: '/app/creator/automations/{automation}/enroll',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Creator\AutomationController::enroll
* @see app/Http/Controllers/Creator/AutomationController.php:226
* @route '/app/creator/automations/{automation}/enroll'
*/
enroll.url = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { automation: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'uuid' in args) {
        args = { automation: args.uuid }
    }

    if (Array.isArray(args)) {
        args = {
            automation: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        automation: typeof args.automation === 'object'
        ? args.automation.uuid
        : args.automation,
    }

    return enroll.definition.url
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Creator\AutomationController::enroll
* @see app/Http/Controllers/Creator/AutomationController.php:226
* @route '/app/creator/automations/{automation}/enroll'
*/
enroll.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: enroll.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::enroll
* @see app/Http/Controllers/Creator/AutomationController.php:226
* @route '/app/creator/automations/{automation}/enroll'
*/
const enrollForm = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: enroll.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Creator\AutomationController::enroll
* @see app/Http/Controllers/Creator/AutomationController.php:226
* @route '/app/creator/automations/{automation}/enroll'
*/
enrollForm.post = (args: { automation: string | { uuid: string } } | [automation: string | { uuid: string } ] | string | { uuid: string }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: enroll.url(args, options),
    method: 'post',
})

enroll.form = enrollForm

const automations = {
    store: Object.assign(store, store),
    show: Object.assign(show, show),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    activate: Object.assign(activate, activate),
    pause: Object.assign(pause, pause),
    duplicate: Object.assign(duplicate, duplicate),
    enroll: Object.assign(enroll, enroll),
}

export default automations